import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-skip-back",
  "use": "icon-skip-back-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-skip-back\" id=\"icon-skip-back\"><polygon points=\"19 20 9 12 19 4 19 20\" /><line x1=\"5\" y1=\"19\" x2=\"5\" y2=\"5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol